/* Graph of Life brand v1.1.0 · tokens.json */
import React from 'react';
import { evidenceStates } from '@/data/proofRegistry';

const toneClass = {
  living: 'text-living-bright border-living-deep bg-living-deep/25 shadow-[0_0_18px_rgba(93,211,158,0.16)]',
  caution: 'text-caution-bright border-caution-deep bg-caution-deep/25 shadow-[0_0_18px_rgba(232,181,75,0.14)]',
  risk: 'text-risk-bright border-risk-deep bg-risk-deep/25 shadow-[0_0_18px_rgba(240,112,92,0.16)]',
};

// State is carried by glyph and word, never by colour alone.
export const EvidenceLabel = ({ state, testId }) => {
  const meta = evidenceStates[state] || evidenceStates.exploratory;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 px-2.5 py-1 border rounded-sm font-mono text-[10px] uppercase tracking-[0.18em] ${toneClass[meta.tone]}`}
    >
      <span aria-hidden="true">{meta.glyph}</span>
      {meta.label}
    </span>
  );
};

export default EvidenceLabel;
